
import React, { Component } from 'react';

import '../../../scss/App.scss';

class EmailSuccessPanel extends Component {
	constructor(props){
		super(props);


		this.state = {
		};

		//



	}

	componentDidMount(){
		this.animateIn();
	}

	animateIn(){
		window.TweenMax.set(this.refs.darkener, {opacity:0});
		window.TweenMax.to(this.refs.darkener, .5, {opacity:1});

		window.TweenMax.set(this.refs.content, {transform:"translate(-50%, -30%)", opacity:0});
		window.TweenMax.to(this.refs.content, .5, {ease:"expo.out", transform:"translate(-50%, -50%)", opacity:1, delay:.2});
	}

	renderCloseBtn(){
		return(
			<div className="closeBtn fa-sharp fa-solid fa-xmark"></div>
		)
	}

	renderHeading(){
		let msg = "Congrats You Won!";

		if(this.props.gaveUp === true){
			msg = "Oh well! Hopefully you learned something!";
		}

		return(
			<div className="heading">{msg}</div>
		)
	}
	

	render(){

		return(
			<div id="EmailSuccessPanel" ref="panel">
				<div className="darkener" ref="darkener"></div>
				<div className="content_wrapper" ref="content">
					<div className="successMsg">Emails sent successfully!</div>
					<div className="plug">AMERICA SAYS <gsntv-wc-tune-in show-id="asdiy-generator"></gsntv-wc-tune-in></div>
					<div className="buttons">
						<a className="playAmericaSaysBtn" href={window.app.configData.playAmericaSaysURL} target="_blank">Play America Says</a>
						<a className="watchEpisodesBtn" href={window.app.configData.watchFullEpisodeURL} target="_blank">Watch Full Episodes</a>
						<a className="playGamesBtn" href={window.app.configData.playOtherGamesURL} target="_blank">Play More Games</a>
					</div>
					<div className="closeBtn fa-sharp fa-solid fa-xmark" onClick={this.props.handleEmailSuccessClose}></div>
				</div>
			</div>
		);
	}

}

export default EmailSuccessPanel;


// WEBPACK FOOTER //
// ./src/js/components/generator/EmailSuccessPanel.js